import { Drawer as AntDrawer, DrawerProps } from "antd"
import { DrawerProvider } from "components/providers/Drawer.provider"
import { ReactNode } from "react"
import type { TCloseDrawer } from "types/default.type"

type Props = {
	width: number
	children: ReactNode
	open: boolean
	onClose: (e: TCloseDrawer) => void
	closeIcon?: boolean
	className?: string
	style?: React.CSSProperties
	styles?: DrawerProps["styles"]
	// Whether pressing Escape closes the drawer (rc-drawer default true). Set false when the drawer
	// hosts its own Escape-owning UI (e.g. the quotation editor): rc-drawer stopPropagations Escape
	// before it reaches window-level handlers, so leaving it on both closes this drawer and swallows
	// the key from the inner UI.
	keyboard?: boolean
}

export const Drawer = ({
	width = 800,
	children,
	open,
	onClose,
	closeIcon = false,
	className = "",
	style,
	styles,
	keyboard = true,
}: Props) => {
	return (
		<DrawerProvider>
			<div data-testid="drawer">
				<AntDrawer
					className={className}
					width={width}
					open={open}
					onClose={onClose}
					closeIcon={closeIcon}
					style={style}
					styles={styles}
					keyboard={keyboard}
				>
					{children}
				</AntDrawer>
			</div>
		</DrawerProvider>
	)
}
